import React from "react";

const CommonDataTableFilterHeader = ({
    pageSize,
    setPageSize,
    globalFilter,
    setGlobalFilter,
    setCurrentPage,
    setGloablFilterType,
    gloablFilterType,
    flage,
    FilterOptions,
}) => {
    const sizeOptions = [5, 10, 25];

    const handlePageSizeChange = (e) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setCurrentPage(1); // Reset to first page
    };

    const handleFilterChange = (e) => {
        setGloablFilterType(e.target.value);
    };

    return (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
                Show{" "}
                <select
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    className="form-select form-select-sm ms-2"
                >
                    {sizeOptions.map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </select>{" "}
            </div>
            <div className="d-flex gap-4 align-items-center">
                {["guestList", "roomStatus"].includes(flage) && (
                    <div>
                        <select
                            value={gloablFilterType}
                            onChange={handleFilterChange}
                            className="form-select form-select-sm ms-2"
                        >
                            {FilterOptions.map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>
                )}


                <div className="d-flex gap-1 align-items-center">
                    <span className="me-2">Search:</span>
                    {gloablFilterType === "Price" ? (
                        <select
                            className="form-select form-select-sm"
                            value={globalFilter}
                            onChange={(e) => {
                                setGlobalFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                        >
                            <option value="">Select Price Range</option>
                            <option value="0-999">Below 999</option>
                            <option value="1000-1999">1000 - 1999</option>
                            <option value="2000-2999">2000 - 2999</option>
                            <option value="3000-4999">3000 - 4999</option>
                            <option value="5000-9999">5000 - 9999</option>
                            <option value="10000-20000">10000 - 20000</option>
                            <option value="20000-50000">Above 20000</option>


                        </select>
                    ) : (
                        <input
                        type={gloablFilterType === "Capacity" ? "number" : "text"}
                            value={globalFilter}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (gloablFilterType === "Capacity") {
                                  if (!/^\d*$/.test(value)) return; 
                                }
                                setGlobalFilter(value);
                              }}
                            placeholder={
                                flage === "roomList" ? "room number . . " : "search here . ."
                            }
                            className="form-control form-control-sm"
                            disabled={gloablFilterType === "Select" }
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CommonDataTableFilterHeader;
